export const iconFontAwesomeMapsPhoneVolume = (
	<i className="fa-solid fa-phone-volume"></i>
);
